if(typeof ProductQuickView == 'undefined') {
    class ProductQuickView extends HTMLElement {
    constructor() {
        super();
        this.button = this.querySelector('button');
        this.popup = document.getElementById('article-popup');
        if(!this.popup) {
            return;
        }
        this.button.addEventListener('click', (event) => {

            event.preventDefault();
            
            this.popup.querySelector('.content').innerHTML = '';
            this.popup.querySelector('.content').classList.add('loading');
            document.querySelector('body').classList.add('article-popup-active');

            var self = this;
            var http = new XMLHttpRequest();
            
            http.onreadystatechange = function () {
                if (this.readyState == 4) {
                    try {
                        // Convert the HTML string into a document object
                        var parser = new DOMParser();
                        var doc = parser.parseFromString(this.response, 'text/html');
                        var elm = self.popup.querySelector('.content');
                        elm.innerHTML = doc.querySelector('#MainContent').innerHTML;
                        elm.classList.remove('loading');
                        elm.querySelector('.shopify-payment-button').remove();
                        Array.from(elm.querySelectorAll("script:not([src])")).forEach( oldScript => {
                            const newScript = document.createElement("script");
                            Array.from(oldScript.attributes).forEach( attr => newScript.setAttribute(attr.name, attr.value) );
                            newScript.appendChild(document.createTextNode(oldScript.innerHTML));
                            oldScript.parentNode.replaceChild(newScript, oldScript);
                        });
                        let event = new Event("swiper-loaded", {bubbles: true});
                        console.log('sl');
                        document.body.dispatchEvent(event);
                    } catch(err) {
                        console.log(err.message + " in " + this.response);
                        return;
                    }
                }
            };
            
            let url = window.shopUrl;
//             url = 'http://127.0.0.1:9292/';
            url += this.button.dataset.href;

            http.open('GET', url, true);
            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            http.send();
        });
    }
    }

    customElements.define('product-quick-view', ProductQuickView);
}